import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { addAsyncCasesNew } from 'shared/utils/redux';

import { fetchCopyPreview, fetchCopySources } from './asyncActions';
import { CopyPreviousSurveyState, STORE_NAME } from './initialState';

export const copyPreviousSurveySlice = createSlice({
  name: STORE_NAME,
  initialState: CopyPreviousSurveyState.INITIAL_DOMAIN,
  reducers: {
    selectCopySource: (state, action: PayloadAction<number>) => {
      state.selectedSourceId = action.payload;
    },
    clearCopySources: (state) => {
      state.sourcesResource = CopyPreviousSurveyState.INITIAL_DOMAIN.sourcesResource;
      state.selectedSourceId = CopyPreviousSurveyState.INITIAL_DOMAIN.selectedSourceId;
    },
    clearCopyPreview: (state) => {
      state.previewResource = CopyPreviousSurveyState.INITIAL_DOMAIN.previewResource;
    },
  },
  extraReducers: (builder) => {
    addAsyncCasesNew(builder, fetchCopySources, (state, action) => {
      state.sourcesResource = action.payload;
    });
    addAsyncCasesNew(builder, fetchCopyPreview, (state, action) => {
      state.previewResource = action.payload;
    });
  },
});

export const { selectCopySource, clearCopySources, clearCopyPreview } =
  copyPreviousSurveySlice.actions;
